import React, { useState, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  // Chip,
} from "@mui/material";
import { ReportContext } from "../../ReportContext";
import Swal from "sweetalert2";

const ReviseProposal = ({
  solutionId,
  reload,
  setReload,
  proposal_notes,
  revision_notes,
}) => {
  const { reviseProposal } = useContext(ReportContext);
  const [open, setOpen] = useState(false);
  const [proposal, setProposal] = useState(
    sessionStorage.getItem(`revised_proposal_${solutionId}`) ||
      proposal_notes ||
      ""
  );
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    setProposal(e.target.value);
    sessionStorage.setItem(`revised_proposal_${solutionId}`, e.target.value);
  };

  const handleSubmit = async () => {
    // console.log("Trigger submit")
    if (!proposal.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Proposal cannot be empty",
        confirmButtonColor: "#f44336",
      });
      return;
    }

    setLoading(true);
    const response = await reviseProposal({
      solution_id: solutionId,
      notes: proposal,
    });

    if (response?.status === "success") {
      sessionStorage.removeItem(`revised_proposal_${solutionId}`);

      await Swal.fire({
        icon: "success",
        title: "Proposal Resubmitted",
        text: "Your updated proposal has been saved.",
        confirmButtonColor: "#4CAF50",
      });

      if (setReload) setReload(!reload);
      handleClose();
    }
    setLoading(false);
  };

  return (
    <>
      {/* Trigger Button */}
      <Button
        variant="contained"
        color="info"
        onClick={handleOpen}
        sx={{ textTransform: "none", fontWeight: 600 }}
      >
        Revise Proposal
      </Button>

      {/* Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: "hidden",
            zIndex: 1600, // ensures above other dialogs
          },
        }}
        sx={{
          "& .MuiBackdrop-root": {
            zIndex: 1599, // backdrop also raised
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", color: "info.main" }}>
          Revise Proposal
        </DialogTitle>

        <DialogContent dividers sx={{ bgcolor: "#fafafa" }}>
          <Box
            sx={{
              mb: 2,
              p: 2,
              borderLeft: "4px solid #ffc107",
              bgcolor: "#fff7e6",
            }}
          >
            <Typography variant="subtitle2" fontWeight={600}>
              Revision Notes
            </Typography>
            <Typography
              variant="body2"
              sx={{ whiteSpace: "pre-wrap", mt: 1 }}
              color="text.secondary"
            >
              {revision_notes || "No revision notes provided."}
            </Typography>
          </Box>

          <TextField
            label="Updated Proposal"
            multiline
            fullWidth
            minRows={8}
            value={proposal}
            onChange={handleChange}
            placeholder="Type your revised proposal here..."
            variant="outlined"
          />
        </DialogContent>

        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={handleClose} color="inherit" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            color="success"
            variant="contained"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReviseProposal;
